import React from 'react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { howItWorksData } from '../data/mockData';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const HowItWorks = () => {
  const scrollToApplication = () => {
    const element = document.getElementById('application-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="how-it-works" className="py-20 relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-slate-50"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
            How It Works
          </h2>
          <p className="text-2xl font-semibold text-blue-700 mb-4">
            {howItWorksData.sectionTitle}
          </p>
          <p className="text-lg text-slate-600 max-w-3xl mx-auto leading-relaxed">
            {howItWorksData.intro}
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {howItWorksData.steps.map((step, index) => (
            <Card
              key={step.number}
              className="relative overflow-hidden border-slate-200 hover:border-blue-400 hover:shadow-xl transition-all duration-300"
            >
              <div className="absolute top-0 left-0 w-2 h-full bg-blue-600"></div>
              <CardContent className="p-8">
                <div className="flex items-start gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-full bg-blue-600 text-white flex items-center justify-center text-2xl font-bold shadow-lg">
                      {step.number}
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-slate-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-slate-600 mb-4 leading-relaxed">
                      {step.description}
                    </p>
                    <div className="bg-slate-50 p-4 rounded-lg border border-slate-200">
                      <p className="text-sm font-medium text-slate-500 mb-2">
                        Deliverables:
                      </p>
                      <p className="text-sm text-slate-700">
                        {step.deliverables}
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Button
            size="lg"
            onClick={scrollToApplication}
            className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105"
          >
            {howItWorksData.steps[0] && "Apply for a Launch Partnership"}
            <ArrowRight className="ml-2 h-5 w-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
